import fastdom from "fastdom";
import moment from "moment/moment";

import type { Event } from "~/calendar/CalendarPage";

export function scrollContentToEvents(events: Event[], date: Date, showWeekend: boolean, firstWeekDay: number) {
	const startDayNum = showWeekend ? firstWeekDay : 1;
	const timeFrom = moment(date).weekday(startDayNum).startOf("day");
	const daysToAdd = showWeekend ? 6 : 4;
	const timeTo = moment(timeFrom).add(daysToAdd, "days").endOf("day");

	let firstEventOfTheDay = null;
	let minimumTime = "23:59";

	for (const event of events) {
		const eventStart = moment(event.start);
		const eventStartTime = eventStart.format("HH:mm");
		if (!event.isAllDay && eventStart.isBetween(timeFrom, timeTo) && eventStartTime < minimumTime) {
			firstEventOfTheDay = event;
			minimumTime = eventStartTime;
		}
	}

	if (!firstEventOfTheDay) return;

	const eventElement = document.getElementById(`event-${firstEventOfTheDay.guid}`);

	if (!eventElement) return;

	const offset = Math.max(eventElement.offsetTop - 50, 0);
	const container = document.getElementsByClassName("fbc-time-content");

	if (!container || container.length === 0) return;

	fastdom.mutate(() => {
		container[container.length - 1]?.scroll?.({ left: 0, top: offset, behavior: "auto" });
	});
}

/**
 * @param delay In milliseconds, how long before the scroll happens. Defaults to 0.
 */
export function scrollEventIntoView(event: Event, delay = 0) {
	return setTimeout(() => {
		const eventElement = document.getElementById(`event-${event.guid}`);
		const containers = document.getElementsByClassName("fbc-time-content");
		const container = containers?.[containers.length - 1];
		if (!container || !eventElement) return;

		const elRelativeTop = eventElement.getBoundingClientRect().top - container.getBoundingClientRect().top;
		const elRelativeBottom = elRelativeTop + eventElement.clientHeight;

		// i.e. if the element is completely on screen
		if (elRelativeTop >= 0 && elRelativeBottom <= container.clientHeight) return;

		fastdom.mutate(() => {
			eventElement.scrollIntoView({ behavior: "smooth", block: "center" });
		});
	}, delay);
}

/**
 * @param delay In milliseconds, how long before the scroll happens. Defaults to 0.
 */
export function scrollToNow(delay = 0) {
	return setTimeout(() => {
		const nowIndicator = document.getElementsByClassName("fbc-current-time-indicator")?.[0];

		if (!nowIndicator) return;

		fastdom.mutate(() => {
			nowIndicator.scrollIntoView({ behavior: "smooth", block: "center" });
		});
	}, delay);
}

/**
 * @param delay In milliseconds, how long before the scroll happens. Defaults to 0.
 */
export function scrollToImaginaryEvent(delay = 0) {
	return setTimeout(() => {
		const container = document.getElementsByClassName("fbc-time-content");
		if (!container || container.length === 0) return;

		const imaginaryEvent = container[container.length - 1].querySelector("[data-event-type='imaginary']");
		if (!imaginaryEvent) return;

		fastdom.mutate(() => {
			imaginaryEvent.scrollIntoView({ behavior: "smooth", block: "center" });
		});
	}, delay);
}
